// Angular
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivationEnd, ResolveStart, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Title } from '@angular/platform-browser';
// Store
import { Store } from '@ngxs/store';
// Model
// Service
import {
	AppInformationService,
	BroadcastEventModel,
	BroadcastService,
	CVLeftNavEventType,
	LeftNavEventType, MAIN_APP_CONFIG_CHANGE,
	ObjectUtils,
	GlobalUtils,
	RoleService,
	ROUTE_NAVIGATION_END_EVENT,
	ROUTE_NAVIGATION_END_START,
	SetCurrentModule,
	SubContentEventType,
	UIConfigBroadcastModel,
	UIConfigComponent,
	UIConfigHideComponentAnimation,
	UIConfigService,
	UIConfigStyle,
	UserContextState,
	FaroSdkService,
	HelpCenterService
} from '@cv-invision/core';
// tslint:disable-next-line: nx-enforce-module-boundaries
// Component
// tslint:disable-next-line: nx-enforce-module-boundaries
import { RULE_UPDATED_EVENT } from '@cv-invision/cv.invision-intelligence.ux';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { GlobalConfigurationMenuHandleService } from '@cv-invision/cv.global-configuration.ux';
// Other
import { distinctUntilChanged, Observable, of, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cv-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [
		trigger('sideExpansion', [
			state('isOpen', style({ width: '*', opacity: 1, flex: '{{flex}}' , visibility: 'visible'}), {
				params: { flex: '0.8' }
			}),
			state('isClose', style({ width: '0px', opacity: 0, flex: 0, visibility: 'hidden' })),
			transition('isOpen <=> isClose', animate('300ms'))
		]),
		UIConfigHideComponentAnimation
	],
	providers: [GlobalConfigurationMenuHandleService]
})
export class AppComponent implements OnInit, OnDestroy {
	@ViewChild('leftNavComponent', { static: false }) leftNavComponent: any;
	@ViewChild('newLeftNavComponent', { static: false }) newLeftNavComponent: any;
	isActive$: Observable<any>;
	isRuleChange$: Observable<any>;
	isBreadcrumbHidden: boolean;
	openLeftNav: boolean;
	updateRulesCounter: boolean;
	navItems$: Observable<Array<any>>;
	subContentPanelFlexWidth: string;
	QUALITY_MODULE = 'quality';
	// TODO: This code will be removed as soon as we integrate the new Menu
	public showNewMenu = false;
	public hideMenu = false;
	private atComponentDestroy = new Subject();
	private currentAppMode: string;
	public currentModule: string;
	public isOnSmartAssign = false;

	public uiConfigComponent = UIConfigComponent;
	public isMainComponentVisible: any = {
		[UIConfigComponent.FOOTER]: {
			show: true,
		},
		[UIConfigComponent.HEADER]: {
			show: true,
		},
		[UIConfigComponent.LEFT_MENU]: {

		}
	};
	public isInsideIframe = false;
	// TODO: This is a workaround only for the incoming release, we need a real solution INNO-6773
	public changePanelPosition = false;
	public showChatbot = false;

	private isSignalFirstRun = true;

	constructor(
		private store: Store,
		private router: Router,
		private broadcastService: BroadcastService,
		public oidcSecurityService: OidcSecurityService,
		private roleService: RoleService,
		private appInfo: AppInformationService,
		private globalConfigurationMenuHandleService: GlobalConfigurationMenuHandleService,
		private uiConfigService: UIConfigService,
		private titleService: Title,
		private faroSdkService: FaroSdkService,
		private helpCenterService: HelpCenterService
	) {
		this.isInsideIframe = GlobalUtils.isInsideIframe();
		this.openLeftNav = true;
		this.registerListeners();
		this.onLoadUIConfig();
	}

	_isSubContentPanelOpen = false;
	get isSubContentPanelOpen(): boolean {
		return this._isSubContentPanelOpen;
	}

	set isSubContentPanelOpen(value: boolean) {
		this._isSubContentPanelOpen = value;
	}

	/**
	 * get the module where should be set the menu items
	 */

	ngOnInit(): void {
		this.isSubContentPanelOpen = this._isSubContentPanelOpen;
		this.isRuleChange$ = this.store.select(s => s.user.navItems);
		this.subContentPanelFlexWidth = '0%';
		this.isRuleChange$.subscribe(async response => {
			if (this.updateRulesCounter && this.router.url.includes(this.QUALITY_MODULE)) {
				if (response) {
					const nav = response.filter((n: any) => n.module === this.QUALITY_MODULE);
					this.navItems$ = of(nav);
				}
			}
		});

		this.broadcastService.on(RULE_UPDATED_EVENT, (broadcast: BroadcastEventModel) => {
			if (broadcast.event.type === 'update-rule-flag') {
				this.updateRulesCounter = true;
			} else {
				this.updateRulesCounter = false;
				if (this.router.url.includes(this.QUALITY_MODULE)) {
					// Update nav items badge
					this.navItems$ = of(
						ObjectUtils.updateNavItemsBadge(broadcast.event.rule, this.navItems$)
					);
				}
			}
		});
		this.registerRouterEvents();
		// init signalR connection
		this.store
			.select(s => s.user.token)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(token => {
				if (token) {
					if (this.isSignalFirstRun) {
						this.isSignalFirstRun = false;
						setTimeout(() => {
							this.roleService.setSignalRbyRole(null);
						}, 5000);
					} else {
						this.roleService.setSignalRbyRole(null);
					}
					this.faroSdkService.setUser(token);
				}
			});
	}

	/**
	 * Toggle SubContent Panel
	 * @param isOpen
	 */
	public toggleSubContentPanel(isOpen: boolean = null): void {
		if (isOpen !== null) {
			this.isSubContentPanelOpen = isOpen;
		} else {
			this.isSubContentPanelOpen = !this._isSubContentPanelOpen;
		}
	}

	/**
	 * toggle left content
	 */
	public toggleLeftNav(): void {
		this.openLeftNav = !this.openLeftNav;
	}

	/**
	 * Register main App Components
	 */
	public registerListeners(): void {
		/**
		 * It open or close the Right Panel (Sub Content)
		 * The control of the opening is in responsibility of every
		 * sub module, since you can have the panel open in one but not in other
		 */
		this.broadcastService.on(SubContentEventType.OPEN_CLOSE, (e: BroadcastEventModel) => {
			setTimeout(() => {
				if (e.event.callback) {
					setTimeout(() => e.event.callback(), 300); // this ms are taken from the [sideExpansion] transition above on this component.
				}
				this.isSubContentPanelOpen = e.event.open;
				this.subContentPanelFlexWidth = e.event.width;
			}, 0);
		});
		/**
		 * It Open or Close the Left Menu Panel
		 */
		this.broadcastService.on(CVLeftNavEventType.OPEN_CLOSE, (e: BroadcastEventModel) => {
			setTimeout(() => {
				this.openLeftNav = e.event;
			}, 0);
		});
		this.broadcastService.on('navItemScrolled', (e: BroadcastEventModel) => {
			const {
				event: { data }
			} = e;
			this.onActivateItem(data);
		});
		this.registerNavItemsEvent();

		this.broadcastService.onEvent('ACTIVATE_HELP_DESK_MENU')
            .pipe(takeUntil(this.atComponentDestroy))
            .subscribe((bem: BroadcastEventModel) => {
                if (bem && bem.event) {
                    this.helpCenterService.isHelpdeskEnabled = bem.event.isHelpDeskActive as boolean;
                }
            });
	}

	/**
	 * It re render the left nav component with new values
	 * This method is used to render dynamic items in the left nav
	 */
	public registerNavItemsEvent(): void {
		this.broadcastService.on(LeftNavEventType.RENDER, (e: BroadcastEventModel) => {
			const {
				event: { items }
			} = e;

			setTimeout(() => {
				this.navItems$ = of(items);
			});
		});
	}

	/**
	 * Manually activate menu item
	 */
	async onActivateItem(index: any): Promise<void> {
		const navItems = await this.navItems$.toPromise();
		if (this.leftNavComponent) {
			await this.leftNavComponent.setItemAsActive(navItems[index]);
		} else if (this.newLeftNavComponent) {
			await this.newLeftNavComponent.setItemAsActive(index);
			setTimeout( async () => {
				// Every time the Nav Items changes update the current model
				this.broadcastService.broadcast({
					name: CVLeftNavEventType.NAV_ITEMS_CHANGED,
					event: {navItems: await this.navItems$.toPromise()}
				});
			});
		}
	}

	/**
	 * On Navigation item click
	 * @param $event
	 */
	onNavItemClick($event: any): void {
		this.broadcastService.broadcast({
			name: 'navItemScrollClicked',
			event: {
				data: {
					id: $event.id,
					itemIndex: $event.scrollIndex,
					itemClass: $event.scrollClass,
					route: $event.route
				}
			}
		});

		if (!$event.action) {
            this.helpCenterService.patchContext({
                location: $event.route || this.router.url,
                action: 'navigate',
                closePanel: true,
                objectType: '',
            });
        }
	}

	/**
	 * Register Router Events to retrieve or set data
	 */
	private registerRouterEvents(): void {
		this.router.events
			.pipe(takeUntil(this.atComponentDestroy))
			.pipe(
				filter(event => event instanceof ResolveStart || event instanceof ActivationEnd),
				map(event => ({
					event: event,
					isResolveStart: event instanceof ResolveStart,
					isActivationEnd: event instanceof ActivationEnd
				}))
			)
			.subscribe((eventRoute: any) => {
				if (eventRoute.isResolveStart) {
					this.broadcastService.broadcast({
						name: ROUTE_NAVIGATION_END_START,
						event: eventRoute.event
					});
				}
				if (eventRoute.isActivationEnd) {
					let { module } = eventRoute.event.snapshot.data;
					if (module) {
						this.currentModule = module;
						this.navItems$ = this.getItemsNavByModule(module);

						this.navItems$.subscribe((items: Array<any> = []) => {
							// Get the Page to Show from the Configuration
							let leftNavItem = items.find(
								(item: any) => item.route === eventRoute.event.snapshot._routerState.url
							);
							// If does not exist get the Default View for that Module
							if (!leftNavItem) {
								leftNavItem = items.find((item: any) => item.defaultView && item.module === module);
							}
							// hacky fix to force the load of the sub-header component under desktop orders routes
							// Issue: what is happening is a race-condition between this broadcast below vs breadcrumb.component listener
							let delay = 0;
							if (module === 'appraisal-desktop-order') {
								delay = 200;
							}

							this.changePanelPosition = (module === 'quality');

							if (['quality', 'intelligence', 'appraisal-desktop', 'appraisal-desktop-order'].indexOf(module) > -1) {
								this.showChatbot = true;
							} else {
								this.showChatbot = false;
							}

							setTimeout(() => {
								this.broadcastService.broadcast({
									name: ROUTE_NAVIGATION_END_EVENT,
									event: {
										routeEvent: eventRoute.event,
										moduleInfo: leftNavItem ? leftNavItem : { subTitle: '' }
									}
								});
							}, delay);
						});
						this.checkAppModeSwitched();
						this.checkNewMenuSwitched();

						// Generic integrations is a submodule of the global configuration module
						module = module === 'generic-integrations' ? 'global-configuration' : module;

						// Update the current module everytime navigation ends.
						this.store.dispatch(new SetCurrentModule(module, this.appInfo.appName));
					}
					// check if breadcrumb has been hidden from the main app layout.
					if (
						eventRoute.event.snapshot.component &&
						eventRoute.event.snapshot.routeConfig.path &&
						eventRoute.event.snapshot.routeConfig.path.length > 0
					) {
						const { breadcrumb } = eventRoute.event.snapshot.data;
						this.isBreadcrumbHidden =
							breadcrumb !== undefined && breadcrumb === false ? true : false;
					}
				}
			});
	}

	/**
	 * Check if app mode has been switch based on the url.
	 */
	private checkAppModeSwitched(): void {
		if (this.router.url && this.router.url.split('/').length > 1) {
			const appMode = this.router.url.split('/')[1];
			if (!this.currentAppMode || this.currentAppMode !== appMode) {
				this.currentAppMode = appMode;
				this.openLeftNav = this.currentAppMode === 'desktop' ? false : true;
			}
		}
	}

	/**
	 * Temporary code to enable or hide new Menu depending the section
	 */
	private checkNewMenuSwitched(): void {
		this.isOnSmartAssign = false;
		if (this.router.url && this.router.url.indexOf('desktop') > 0) {
			this.showNewMenu = true;
			this.hideMenu = false;
		} else if (
			this.router.url &&
			(this.router.url.indexOf('global-configuration/product/create') > 0 ||
				this.router.url.indexOf('global-configuration/product/edit') > 0)
		) {
			this.hideMenu = true;
		} else if (this.router.url && this.router.url.indexOf('global-configuration/') >= 0) {
			this.showNewMenu = true;
			this.hideMenu = false;
		} else if (
			(this.router.url && this.router.url.indexOf('rule/create') > 0) ||
			(this.router.url && this.router.url.indexOf('rule/edit') > 0)
		) {
			this.hideMenu = true;
		}  else if(this.router.url && this.router.url.indexOf('smart-assign') > 0){
			this.showNewMenu = false;
			this.hideMenu = true;
			this.isOnSmartAssign = true;
		} else {
			this.hideMenu = false;
			this.showNewMenu = false;
		}
	}

	/**
	 * Get the module where should be set the menu items
	 */
	private getItemsNavByModule(currentModule: string): Observable<Array<any>> {
		this.updateRulesCounter = false;

		const storeLocalUserContext = this.store.selectSnapshot(state => state.user);

		if (currentModule) {
			this.isActive$ = this.store.select(s => s.user.isActive);
		}
		let navItems: any = [];

		if (currentModule === 'appraisal-desktop-order') {
			// tslint:disable-next-line:no-shadowed-variable
			const storeLocalDesktop = this.store.selectSnapshot(state => state.appraisalDesktop);
			if (storeLocalDesktop && storeLocalDesktop.orderDesktop) {
				navItems = JSON.parse(JSON.stringify(storeLocalDesktop.orderDesktop.menu));
			}
		} else if (currentModule === 'quality') {
			this.updateRulesCounter = true;
			// tslint:disable-next-line:no-shadowed-variable
			const storeLocalQuality = this.store.selectSnapshot(state => state.quality);
			if (storeLocalQuality && storeLocalQuality.menu) {
				// Get new Menu
				navItems = JSON.parse(JSON.stringify(storeLocalQuality.menu));
				// Get Badges if a user transitions from URL
				if (storeLocalUserContext && storeLocalUserContext.navItems) {
					navItems.forEach(item => {
						const navItem = storeLocalUserContext.navItems.find((n: any) => n.route === item.route);
						if (navItem) {
							item.badge = navItem.badge;
						}
					});
				}

			}
		} else if (currentModule === 'global-configuration') {
			navItems = this.globalConfigurationMenuHandleService.getMenuNavigation();
		} else if (currentModule === 'generic-integrations') {
			const storeLocalDesktop = this.store.selectSnapshot(state => state.globalConfiguration.genericIntegration);
			if (storeLocalDesktop && storeLocalDesktop.menu) {
				navItems = JSON.parse(JSON.stringify(storeLocalDesktop.menu));
			}
		}  else if (currentModule === 'smart-assign') {
			navItems = [
				{
					label: 'Home',
					route: '/smart-assign/'  ,
				}
			]
		} else {
			navItems = this.store
				.selectSnapshot(UserContextState.getNavItems)
				.filter((n: any) => n.module === currentModule);
		}

		const permissions = storeLocalUserContext.permission;
		if (permissions && permissions.length > 0) {
			navItems = navItems.filter((item: any) => {
				if (!item.permissions || item.permissions.length === 0) {
					return true;
				}
				return item.permissions.some((permission: string) => permissions.includes(permission));
			});
		}

		return of(navItems)
	}

	/**
	 * Get Header Configuration
	 * Reason to get it inside and not outside is because there can be logic or listeners
	 * as part of the Header applying an ngIF could break some functionality
	 * @private
	 */
	private onLoadUIConfig(): void {
		// If something changes again, open only for this component, this allows to change the configuration on fly
		this.uiConfigService.onUiConfigModelChange
			.pipe(
				distinctUntilChanged(),
				filter((uiConfigBroadcastModel: UIConfigBroadcastModel) =>
					MAIN_APP_CONFIG_CHANGE.indexOf(uiConfigBroadcastModel.component) !== -1
				)
			)
			.subscribe((uiConfigBroadcastModel: UIConfigBroadcastModel) => {
				this.changeStyles();
			});
	}

	/**
	 * Update Styles on changes
	 * @private
	 */
	private changeStyles(): void {
		const uiConfigTitle: string = this.uiConfigService.getComponentStyle(UIConfigComponent.TITLE);
		const uiConfigFavicon: string = this.uiConfigService.getComponentStyle(UIConfigComponent.FAVICON);
		const headerStyle: UIConfigStyle = this.uiConfigService.getComponentStyle(UIConfigComponent.HEADER);
		const footerStyle: UIConfigStyle = this.uiConfigService.getComponentStyle(UIConfigComponent.FOOTER);
		const leftMenuStyle: UIConfigStyle = this.uiConfigService.getComponentStyle(UIConfigComponent.LEFT_MENU);

		// const isInsideIframe = GlobalUtils.isInsideIframe();
		const isInsideIframe = this.isInsideIframe;

		if (uiConfigFavicon) {
			const favicon: HTMLLinkElement = document.querySelector('#mainFavicon');
			if (favicon) {
				favicon.href = uiConfigFavicon;
			}
		}

		if (uiConfigTitle) {
			this.titleService.setTitle(uiConfigTitle);
		}

		if (headerStyle && 'show' in headerStyle) {
			// Even if the user decide to hide the Header, this only applies inside an Iframe
			this.isMainComponentVisible[UIConfigComponent.HEADER].show = (headerStyle.show || !isInsideIframe);
		}

		if (footerStyle && 'show' in footerStyle) {
			this.isMainComponentVisible[UIConfigComponent.FOOTER] = footerStyle;
		}

		if (leftMenuStyle) {
			this.isMainComponentVisible[UIConfigComponent.LEFT_MENU] = leftMenuStyle;
		}
	}

	/**
     * Handles custom actions emitted by the left-nav component.
     * Broadcasts the event so other services (e.g. HelpCenterService) can react.
     * @param $event - The CustomActions enum value emitted by the nav item.
     */
    onCustomAction($event: any): void {
        this.broadcastService.broadcast({
            name: 'HELPDESK_CUSTOM_ACTION',
            event: $event
        });
    }

	/**
	 * Close all when the element is destroyed
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
